import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconHeart02 = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M18.27 7.006c-2.28.262-4.685 1.046-6.61 2.154-1.437.828-2.473 1.618-3.636 2.774-2.802 2.785-4.47 6.173-5.024 10.21-.107.782-.11 3.298-.004 4.096.525 3.979 2.195 7.432 4.905 10.15.923.925 21.005 19.502 21.434 19.827 1.533 1.162 3.799 1.162 5.33 0 .245-.186 11.857-10.906 21.136-19.512.89-.826 2.027-2.243 2.744-3.42 1.325-2.177 2.108-4.423 2.457-7.045.136-1.02.102-3.381-.065-4.467-.326-2.119-.863-3.772-1.822-5.609-2.277-4.359-6.411-7.592-11.217-8.772-2.112-.519-4.857-.62-6.97-.256-3.136.54-6.113 1.941-8.463 3.984l-.463.403-.561-.484c-2.403-2.071-5.532-3.484-8.797-3.972-.933-.139-3.396-.173-4.373-.061" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconHeart02.displayName = 'IconHeart02';